import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { Button, Grid, Theme } from 'web-library';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  container: {
    marginTop: theme.spacing(3),
  },
  backButton: {
    marginRight: theme.spacing(2),
    height: 'fit-content',
  },
  proceedButton: {
    height: 'fit-content',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
}));

interface NavigationButtonsProps {
  backLabel: string;
  onBackClick: () => void;
  procceedLabel: string;
  onProceedClick: () => void;
  showProceedButton?: boolean;
  isDisabledProceedButton?: boolean;
}

const NavigationButtons = ({
  backLabel,
  procceedLabel,
  onBackClick,
  onProceedClick,
  showProceedButton = true,
  isDisabledProceedButton = false,
}: NavigationButtonsProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { classes } = useStyles();

  return (
    (<Grid
      xs={12}
      className={classes.container}
      direction={isMobile ? 'column' : 'row'}
      wrap="nowrap"
      container
      alignItems="center"
      justify="flex-start"
    >
      <Button
        id="button-back-to-application"
        onClick={onBackClick}
        className={classes.backButton}
        fullWidth={isMobile}
        variant="outlined"
      >
        {backLabel}
      </Button>
      {showProceedButton && (
        <Button
          id="button-confirm-withdrawal"
          onClick={onProceedClick}
          className={classes.proceedButton}
          fullWidth={isMobile}
          disabled={isDisabledProceedButton}
          variant="contained"
        >
          {procceedLabel}
        </Button>
      )}
    </Grid>)
  );
};

export default NavigationButtons;
